import React, {
    useState
} from "react"
import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Typography,
    Button,
    Container,
    Box,
    useTheme,
    useMediaQuery,
    List,
    ListItemText,
    ListItem,
    Checkbox,
    ListItemButton
} from "@mui/material"
import {generateRandomId} from "../utils/hooks"
import {
    Download
} from "@mui/icons-material"

const months = [
    "January", "February", "March", "April",
    "May", "June", "July", "August",
    "September", "October", "November", "December"
];

const MonthlyCards = ({
    onCardClick,
    studentData = null,
    studentPaidList = [],
    monthlyFee = [],
    handleDownloadFeeReceipt,
    selectedClass
}) => {
    const currentYear = new Date().getFullYear()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("md"))
    const [selectedFee, setSelectedFee] = useState([])

    const paidMonthlyFees = studentPaidList.filter((fee) => {
        const payment_date = fee.payment_date
        const year = payment_date.split("/")[2]
        if (fee.fee_name === "monthly_fee" && currentYear.toString() === year) {
            return fee
        } else {
            return null
        }
    }).filter(i => i)


    return (
        <Container maxWidth="xl">
            {/* Page Header */}
            <Box mb={3}>
                <Typography variant="h5" fontWeight={600}>
                    Year's Monthly Fee Collections Overview
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {currentYear}
                </Typography>
            </Box>

            <Grid container spacing={3} alignItems="stretch">
                {months.map((month,index) => {
                    let monthIndex = index +1
                    let isAlreadyPaid = false
                    let paidFeeData = null,payment_date = null
                    Array.isArray(paidMonthlyFees) && paidMonthlyFees.forEach((m)=> {
                        let monthIndexPaid = m.payment_date.split("/")[1]
                        if(monthIndex == monthIndexPaid){
                            isAlreadyPaid = true
                            payment_date = m.payment_date
                            paidFeeData = m
                        }
                    })
                    return (
                        <Grid
                            item
                            key={month}
                            xs={12}   // Mobile → 1 card per row
                            md={4}    // Laptop & above → 3 cards per row
                            sx={{
                                width: isMobile ? "100%" : "30%",
                                boxShadow: "-moz-initial"
                            }}
                        >
                            <Card
                                component="section"
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    borderRadius: 2,
                                    width: "100%",
                                    background: isAlreadyPaid ? "linear-gradient(135deg, #523b8fff 0%, #7c3737ff 100%)" : "linear-gradient(135deg, #ffffff 0%, #fafafa 100%)",
                                    transition: "all 0.3s ease",
                                    cursor: "pointer",

                                    "&:hover": {
                                        transform: "translateY(-6px)",
                                        boxShadow: isAlreadyPaid && "0px 12px 28px rgba(0,0,0,0.12)",
                                        background: !isAlreadyPaid && "linear-gradient(135deg, #f9fafe 0%, #f1f5ff 100%)"
                                    }
                                }}
                            >
                                <CardHeader
                                    component="header"
                                    sx={{
                                        transition: "background-color 0.3s ease",
                                        "&:hover": {
                                            backgroundColor: "rgba(25, 118, 210, 0.04)"
                                        }
                                    }}
                                    title={
                                        <Typography variant="h6" fontWeight={600}>
                                            {month}
                                        </Typography>
                                    }
                                    subheader={currentYear}
                                />


                                <CardContent component="main" sx={{ flexGrow: 1, pt: 0 }}>
                                    <Typography variant="body2" color="text.secondary">
                                        Monthly summary and actions related to {month}.
                                    </Typography>
                                    {
                                        monthlyFee && monthlyFee.length > 0 && (
                                            <List>
                                                {
                                                    monthlyFee.map((item, index) => {
                                                        let isExist = selectedFee.find(i => i.month === month && i.feeName === item.feeName)
                                                        return (
                                                            <ListItemButton
                                                                key={item.feeName + index}
                                                                onClick={() => {
                                                                    let isExist = selectedFee.find(i => i.month === month && i.feeName === item.feeName)
                                                                    if (isExist) {
                                                                        const removeList = selectedFee.filter(i => i.month !== month && i.feeName !== item.feeName)
                                                                        setSelectedFee([...removeList])
                                                                    } else {
                                                                        setSelectedFee([...selectedFee, {
                                                                            month: month,
                                                                            feeName: item.feeName,
                                                                            feeAmount: item.feeAmount
                                                                        }
                                                                        ])
                                                                    }
                                                                }}
                                                                disabled={isExist || isAlreadyPaid}
                                                            >
                                                                <ListItem>
                                                                    <ListItemText primary={item.feeName} />
                                                                    <ListItemText primary={`Rs-${item.feeAmount}`} />
                                                                    <Checkbox
                                                                        checked={isExist || isAlreadyPaid}
                                                                    />
                                                                </ListItem>
                                                            </ListItemButton>
                                                        )
                                                    })
                                                }
                                            </List>
                                        )
                                    }
                                </CardContent>

                                <CardActions
                                    component="footer"
                                    sx={{
                                        px: 2,
                                        py: 1.5,
                                        mt: "auto",
                                        justifyContent: "flex-end",
                                        borderTop: "1px solid",
                                        borderColor: "divider",
                                        gap: "4px"
                                    }}
                                >
                                    <Button
                                        size="small"
                                        sx={{
                                            transition: "all 0.2s ease",
                                            "&:hover": {
                                                transform: "scale(1.05)"
                                            }
                                        }}
                                        startIcon={<Download />}
                                        variant="outlined"
                                        disabled = {!isAlreadyPaid}
                                        onClick={()=> {
                                            if(!paidFeeData || !payment_date || !selectedClass) return
                                            const data = {
                                                receipt_title:"Monthly Fee Payment Receipt",
                                                student_name:studentData.name,
                                                class_name:selectedClass.class_name,
                                                application_no:generateRandomId(14),
                                                receipt_date:payment_date,
                                                roll_no:studentData.roll_no,
                                                fee_items:[{
                                                    name:paidFeeData.fee_name,
                                                    amount:paidFeeData.fee_amount
                                                }]
                                            }
                                            handleDownloadFeeReceipt(data)
                                        }}
                                    >
                                        Download Receipt
                                    </Button>

                                    <Button
                                        size="small"
                                        variant="contained"
                                        sx={{
                                            transition: "all 0.2s ease",
                                            "&:hover": {
                                                boxShadow: "0px 6px 16px rgba(25,118,210,0.35)"
                                            }
                                        }}
                                        onClick={() => {
                                            if (!studentData || selectedFee.length === 0) return
                                            let totalPaidAmount = 0
                                            selectedFee.forEach(i => {
                                                totalPaidAmount = totalPaidAmount + Number(i.feeAmount)
                                            })
                                            if (Number(totalPaidAmount) == 0) return
                                            let monthIndex = months.indexOf(month)
                                            const data = {
                                                school_ref: studentData?.school_ref,
                                                student_ref: studentData?.id,
                                                fee_name: "monthly_fee",
                                                fee_amount: totalPaidAmount,
                                                payment_date: `${new Date().getDate()}/${monthIndex + 1}/${new Date().getFullYear()}`
                                            }
                                            onCardClick(data)
                                        }}
                                        disabled={isAlreadyPaid}
                                    >
                                        Collect Fee
                                    </Button>

                                </CardActions>
                            </Card>
                        </Grid>
                    )
                })}
            </Grid>

        </Container>
    );
};

export default MonthlyCards;
